import React from "react";
import "../assets/css/flags.css";

class TechnicalCommittee extends React.Component {
  componentDidMount() {
    document.title =
      "CAAIE " +
      new Date().getFullYear() +
      ": Conference on Advanced Artificial Intelligence and Education (CAAIE)";
  }
  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Technical committee</h1>
                  </div>
                </div>

                <div className="intro_text text-center">
                  <ul style={{ listStyleType: "circle" }} align="left">
                    <li>
                      Federico Lanzalonga, University of Turin, Italy Italy
                    </li>
                    <li>Michele Oppioli, University of Turin, Italy</li>
                    <li>Ginevra Degregori, University of Turin,Italy Italy</li>
                    <li>Protopapa Simona University of Turin, Italy</li>
                    <li>Saccà Angelo, University of Turin, Italy</li>
                    <li>
                      Adnan, Awais, Institute of Management Sciences, Pakistan
                    </li>
                    <li>Alurkar, Aakash, Zoom Communication, San Jose, USA</li>
                    <li>
                      Ahmad ,Amro Al-Said, Philadelphia University, Jordan
                    </li>
                    <li>
                      Ahmad Mughal, Imran, Institute of Management Sciences,
                      Pakistan
                    </li>
                    <li>Ahmad, Ibrar, University of Peshawar , Paksitan</li>
                    <li>Ahmad, Ishtiaq, University of South , Australia</li>
                    <li>
                      Ahmad, Jamil, Islamia College University Peshawar,
                      Pakistan
                    </li>
                    <li>Akay, Metin, Arizona State University, USA</li>
                    <li>
                      Ali Khan, Arif, Nanjing University of Aeronautics and
                      Astronautics , Paksitan
                    </li>
                    <li>Ali Khan, Wajahat,&nbsp; University of Derby , UK</li>
                    <li>
                      Ali Syed ,Toqeer, Islamic University of Medina , Saudi
                      Arabia
                    </li>
                    <li>Ali, Shaukat, University of Peshawar, Pakistan</li>
                    <li>
                      Amin, Adnan, Institute of Management Sciences , Pakistan
                    </li>
                    <li>
                      Ammar, Adel, Prince Sultan University , Saudi Arabia
                    </li>
                    <li>
                      Andres, Frederic, National Institute of Informatics, Japan
                    </li>
                    <li>Araki, Kenji, Hokkaido University, Japan</li>
                    <li>Barker, Trevor, University of Hertfordshire , UK</li>
                    <li>
                      Barolli, Leonard, Fukuoka Institute of Technology , Japan
                    </li>
                    <li>
                      Beavan, Jay, Health Education and Improvement Wales UK
                    </li>
                    <li>Bilal, Mohsin, University of Warwick , UK</li>
                    <li>Brassey, Jon, Oxford University , UK</li>
                    <li>Butcher, John, Aston University , UK</li>
                    <li>Chbeir, Richard, Universite de Bourgogne, France</li>
                    <li>
                      Chen, Shaokang, The University of Queensland, Australia
                    </li>
                    <li>
                      Cheok, Adrian David, National University of Singapore
                    </li>
                    <li>Choi, Jaeho, Chonbuk National University, Korea</li>
                    <li>Dooley, Laurence S, Monash University, Australia</li>
                    <li>Durresi, Arjan, Louisiana State University, USA</li>
                    <li>Fernandez, George, RMIT, Australia</li>
                    <li>Finley, Marion R. Jr., Asahi University, Japan</li>
                    <li>Forughian, Tooraj, BBS Access Pte Ltd, Singapore</li>
                    <li>
                      Fu, Jiacai, Heilongjiang Institute of Science And
                      Technology , Singapore
                    </li>
                    <li>Fujita, Satoshi, Hiroshima University, Japan</li>
                    <li>Fung, Lance, Murdoch University, Australia</li>
                    <li>Gandelli, Alessandro, Politecnico di Milano, Italy</li>
                    <li>
                      Gohar, Neelam, Shaheed Benazir Bhutto Women University
                      Peshawar, Pakistan
                    </li>
                    <li>
                      Habib, Asad, Kohat university of science and technology,
                      Kohat, Pakistan
                    </li>
                    <li>
                      Haleem, Zahid, Ghulam ishaq institute of Engineering
                      Sciences and Technology, Pakistan
                    </li>
                    <li>Helia Guerra, University of the Azores, Portugal</li>
                    <li>
                      Henrique da Mota Silveira, University of Campinas
                      (UNICAMP), Brazil
                    </li>
                    <li>Henrique S. Mamede, University Aberta, Portugal</li>
                    <li>
                      Henrique Vicente, University of &Eacute;vora, Portugal
                    </li>
                    <li>
                      Hugo Paredes, INESC TEC and University of
                      Tr&aacute;s-os-Montes e Alto Douro, Portugal
                    </li>
                    <li>
                      Igor Aguilar Alonso, Universidad Nacional
                      Tecnol&oacute;gica de Lima Sur, Peru
                    </li>
                    <li>
                      In&ecirc;s Domingues, University of Coimbra, Portugal
                    </li>
                    <li>
                      Isabel Lopes,&nbsp;Polytechnic of Bragan&ccedil;a,
                      Portugal
                    </li>
                    <li>
                      Isabel Pedrosa, Coimbra Business School - ISCAC, Portugal
                    </li>
                    <li>Ivone Amorim, University of Porto, Portugal</li>
                    <li>Jabeen, Hajira, University of Cologne , Germany</li>
                    <li>Jalil ,Zunera, Air University Islamabad , Pakistan</li>
                    <li>
                      Jan, Zahoor, Islamia College University Peshawar, Pakistan
                    </li>
                    <li>Joao Carlos Silva, IPCA, Portugal</li>
                    <li>
                      Joo Manuel R.S. Tavares, University of Porto, FEUP,
                      Portugal
                    </li>
                    <li>
                      Joao Paulo Pereira, Polytechnic of Bragan&ccedil;a,
                      Portugal
                    </li>
                    <li>Joao Reis, University of Aveiro, Portugal</li>
                    <li>Joao Rodrigues, University of the Algarve, Portugal</li>
                    <li>Jorge Barbosa, Polythecnic of Coimbra, Portugal</li>
                    <li>
                      Jorge Buele,Technical University of Ambato, Ecuador Jorge
                      Gomes, University of Lisbon, Portugal
                    </li>
                    <li>
                      Jorge Oliveira e S&aacute;, University of Minho, Portugal
                    </li>
                    <li>
                      Jos&eacute; Braga de Vasconcelos, Universidade New
                      Atl&acirc;ntica, Portugal
                    </li>
                    <li>
                      Jose Luis Sierra, Complutense University of Madrid, Spain
                    </li>
                    <li>
                      Jose M Parente de Oliveira, Aeronautics institute of
                      Techology, Brazil
                    </li>
                    <li>Jos&eacute; Machado, University of Minho, Portugal</li>
                    <li>
                      Jos&eacute; Paulo Lousado, Polythecnic of Viseu, Portugal
                    </li>
                    <li>Jose Quiroga, University of Oviedo, Spain</li>
                    <li>Jose Torres, Universidty Fernando Pessoa, Portugal</li>
                    <li>Khan, Ahmad, Comsats University Islamabad, Pakistan</li>
                    <li>
                      Khan, Sifat Ullah, University of Malakand , Pakistan
                    </li>
                    <li>Khattak, Asad, Zayed University , Pakistan</li>
                    <li> Kundi, Mahwish, Maynooth University, Ireland</li>
                    <li>
                      Khattak, Hassan Ali, Comsat University Islamabad, Pakistan
                    </li>
                    <li>
                      Luis Mendes Gomes, University of the Azores, Portugal
                    </li>
                    <li>
                      Luis Silva Rodrigues, Polythencic of Porto, Portugal
                    </li>
                    <li>Luke, Karl, Cardiff University, Pakistan</li>
                    <li>
                      Majid Bhatti, Baber, University of South , Australia
                    </li>
                    <li>
                      Manuel Antonio Fern&aacute;ndez-Villaca&ntilde;as
                      Mar&iacute;n, Technical University of Madrid, Spain
                    </li>
                    <li>
                      Manuel Au-Yong-Oliveira, University of Aveiro, Portugal
                    </li>
                    <li>
                      Manuel Ignacio Ayala Chauvin, University Indoamerica,
                      Ecuador
                    </li>
                    <li>
                      Manuel Silva, Polytechnic of Porto and INESC TEC, Portugal
                    </li>
                    <li>
                      Manuel Tupia, Pontifical Catholic University of Peru, Peru
                    </li>
                    <li>
                      Maria Jo&atilde;o Ferreira, Universidade Portucalense,
                      Portugal
                    </li>
                    <li>
                      Maria Jo&atilde;o Varanda Pereira, Polytechnic of
                      Bragan&ccedil;a, Portugal
                    </li>
                    <li>
                      Maria Jos&eacute; Sousa, Instituto Universit&aacute;rio de
                      Lisboa, Portugal
                    </li>
                    <li>
                      Marisol Garcia-Valls,&nbsp;Polytechnic University of
                      Valencia, Spain
                    </li>
                    <li>
                      Marlene Goncalves da Silva, Universidad Sim&oacute;n
                      Bol&iacute;var, Venezuela
                    </li>
                    <li>
                      Mehmood Minhas, Nasir,&nbsp; Blekinge Institute of
                      Technology, Sweden
                    </li>
                    <li>Mehmood, Irfan, University of Bradford , UK</li>
                    <li>Miguel Garcia, University of Oviedo, Spain</li>
                    <li>
                      Moreira, Fernando,&nbsp; Portucalense University, Portugal
                    </li>
                    <li>Muhammad, Khan, Sejong University, Korea</li>
                    <li>
                      Naseem, Rashid, Pak-Austria Fachhochschule Institute of
                      Applied Sciences and Technology , Austria
                    </li>
                    <li>Nazir, Shah, University of Swabi , Pakistan</li>
                    <li>Nelson Rocha, University of Aveiro, Portugal</li>
                    <li>
                      Noor, Salma, Olsen College of Engineering and Science,
                      Fairleigh Dickinson University, Vancouver, Canada
                    </li>
                    <li>Nuno Mel&atilde;o, Polytechnic of Viseu, Portugal</li>
                    <li>
                      Nuno Oct&aacute;vio Fernandes, Polytechnic of Castelo
                      Branco, Portugal
                    </li>
                    <li>Nuno Pombo, University of Beira Interior, Portugal</li>
                    <li>Obeidat, Qasem, University of Bahrain , Bahrain</li>
                    <li>
                      Panichella, Sebastiano&nbsp;&nbsp; Zurich University of
                      Applied Science, Switzerland
                    </li>
                    <li>
                      Patricia Zachman, Universidad Nacional del Chaco Austral,
                      Argentina
                    </li>
                    <li>
                      Paul, Enoiu, Eduard&nbsp; M&auml;lardalen University,
                      Sweden
                    </li>
                    <li>
                      Paula Serdeira Azevedo, University of Algarve, Portugal
                    </li>
                    <li>Paulo Maio, Polytechnic of Porto, ISEP, Portugal</li>
                    <li>Paulo Novais, University of Minho, Portugal</li>
                    <li>
                      Pedro Rangel Henriques, University of Minho, Portugal
                    </li>
                    <li>Pedro Sobral, University Fernando Pessoa, Portugal</li>
                    <li>Pedro Sousa, University of Minho, Portugal</li>
                    <li>Qayyum, Fawad, University of Malakand , Pakistan</li>
                    <li>Rafael Caldeirinha, Polytechnic of Leiria, Portugal</li>
                    <li>
                      Ramzan, Muhammad, Saudi Electronic University , Saudi
                      Arabia
                    </li>
                    <li>
                      Rauf, Abdul, RISE-Research Institute of Sweden in
                      Vasteras, Sweden
                    </li>
                    <li>Razzak, Imran, Deakin University , Australia</li>
                    <li>
                      Rodrigo Franklin Frogeri, University Center of Minas
                      Gerais South, Brazil
                    </li>
                    <li>Rui Alexandre Castanho, WSB University, Poland</li>
                    <li>Rui Jose, University of Minho, Portugal</li>
                    <li>
                      Rui S. Moreira, UFP &amp; INESC TEC &amp; LIACC, Portugal
                    </li>
                    <li>
                      Sajid Anwar, Institute of Management Sciences Peshawar,
                      Pakistan
                    </li>
                    <li>Saman, Gule, Herriotwatt University , UK</li>
                    <li>Samuel Sepulveda, University of La Frontera, Chile</li>
                    <li>
                      Sandra Patricia Cano Mazuera, University of San
                      Buenaventura Cali, Colombia
                    </li>
                    <li>
                      S&eacute;rgio Ivan Lopes, Polytechnic of Viana do Castelo,
                      Portugal
                    </li>
                    <li>Shah, Babar, Zayed University , UAE</li>
                    <li>Sonia Morgado, ISCPSI, Portugal</li>
                    <li>Sonia Sobral, Portucalense University, Portugal</li>
                    <li>
                      Usman, Muhammad, Blekinge Institute of Technology , Sweden
                    </li>
                    <li>Victor Alves, University of Minho, Portugal</li>
                    <li>
                      Victor Hugo Medina Garcia, Universidad Distrital Francisco
                      Jos&eacute; de Caldas, Colombia
                    </li>
                    <li>
                      Waseem Ahmad, Raja, College of Engineering and IT, Ajman
                      University, UAE
                    </li>
                    <li>
                      Wiem, Mkaouer, Mohamed Rochester Institute of Technology,
                      New York, USA
                    </li>
                    <li>
                      Williams, Jason, Cardiff Metropolitan University , UK
                    </li>
                    <li>Xiao, Hannan, Kings College London ,UK</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TechnicalCommittee;
